import { format } from "date-fns"
import { enGB as en, pl } from "date-fns/locale"

export const formatDate = (date: string, lang = "pl", string = "do MMMM yyyy HH:mm") => {
  return format(new Date(date), string, {
    locale: lang === "pl" ? pl : en,
  })
}
